import React from 'react';
import { RadixHoverDropdown } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
}

export const OtherTab: React.FC<OtherTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Diễn giải</Label>
          <FormField type='text' name='dien_giai' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mẫu lọc báo cáo:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='report_filtering'
              type='select'
              options={[{ value: '0', label: 'Người dùng tự lọc' }]}
              defaultValue={'0'}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={624}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => undefined
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Lưu đè vào mẫu đang chọn',
                    icon: 75,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
